import { render, staticRenderFns } from "./Wording.vue?vue&type=template&id=758294f2"
import script from "./Wording.vue?vue&type=script&lang=js"
export * from "./Wording.vue?vue&type=script&lang=js"
import style0 from "./Wording.vue?vue&type=style&index=0&id=758294f2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports